"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_threshold_stroke_dash_array_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_threshold_stroke_dash_array"));
const chart_threshold_stroke_Width_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_threshold_stroke_Width"));
// Threshold theme
exports.ThresholdTheme = {
    line: {
        style: {
            data: {
                strokeDasharray: chart_threshold_stroke_dash_array_1.default.value,
                strokeWidth: chart_threshold_stroke_Width_1.default.value
            }
        }
    }
};
//# sourceMappingURL=threshold-theme.js.map